import React from 'react';
import { AwardIcon } from 'lucide-react';
import { honors } from '../data/profile';
export function HonorsBanner() {
  return <section className="bg-navy pb-20 pt-4 lg:pb-24" data-id="element-114" data-mp="ulr0c42rwa0d">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-115" data-mp="fq1imi4mej1g">
        <ul className="mt-8 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-116" data-mp="fpjfd1jjj4k1">
          {honors.map(honor => <li key={honor.name} className="flex items-start gap-4 bg-navy p-6" data-id="element-117" data-mp="kqpat74l55x9">
              <AwardIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-118" data-mp="bnxxf1s5g02z" />
              <div data-id="element-119" data-mp="3t68zrty8426i">
                <p className="text-base font-semibold leading-snug text-white" data-id="element-120" data-mp="3t2l5gskyfbqq">
                  {honor.name}
                </p>
                <p className="mt-1 text-sm text-slate-400" data-id="element-121" data-mp="3k49cwl0j23vn">{honor.issuer}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}